window.bundleDataX = {
"Xavier-boy": {
displayName: "Xavier",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Xavier Personalized Coloring Experience",
variantId: "49414809420013",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Xavier.png?v=1772144773",
price: "$14.99",
preorder: true
},
{
title: "Xavier Dragon Holographic Sticker",
variantId: "49933760102637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Xavier_holographic_sticker.png?v=1780106109",
price: "$4.99",
preorder: false
},
{
title: "Xavier Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Ximena-girl": {
displayName: "Ximena",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ximena Personalized Coloring Experience",
variantId: "49666679963885",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ximena_final_cover.png?v=1773592232",
price: "$14.99",
preorder: true
},
{
title: "Ximena Unicorn Holographic Sticker",
variantId: "49933754073325",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ximena_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Ximena Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Xylia-girl": {
displayName: "Xylia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Xylia Personalized Coloring Experience",
variantId: "49929699983597",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Xylia_final_cover.png?v=1777863212",
price: "$14.99",
preorder: true
},
{
title: "Xylia Unicorn Holographic Sticker",
variantId: "49933745586413",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Xylia_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Xylia Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Xander-boy": {
displayName: "Xander",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Xander Personalized Coloring Experience",
variantId: "50180886462701",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Xander_final_cover.png?v=1782611321",
price: "$14.99",
preorder: true
},
{
title: "Xander Dragon Holographic Sticker",
variantId: "50180828889325",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Xanderwebsitesticker.png?v=1782610917",
price: "$4.99",
preorder: false
},
{
title: "Xander Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} 



};